import { Component, inject } from '@angular/core';
import { LocaleService } from '../../i18n/locale.service';
import { TranslatePipe } from '../../i18n/translate.pipe';

@Component({
  selector: 'cmi-language-settings',
  imports: [TranslatePipe],
  templateUrl: './lang.html'
})
export class LanguageSettings {
  private readonly _localeService = inject(LocaleService);

  public readonly currentLocale = this._localeService.currentLocale;

  public selectLanguage(locale: 'de' | 'fr'): void {
    void this._localeService.switchLanguage(locale);
  }
}
